import React from "react";
import { Link } from "react-router-dom";
import { Bell, Package, Tag, Sparkles, Gift, Info } from "lucide-react";

const ICONS = { order: Package, offer: Tag, product: Sparkles, reward: Gift, info: Info };

const NOTIFICATIONS = [
  { id: "n1", type: "order",   title: "Your last order shipped",              body: "Order #DS-24012 is out for delivery — expected by tomorrow evening.", href: "/orders",         time: "2h ago" },
  { id: "n2", type: "offer",   title: "Bulk buy — extra 15% off ends tonight", body: "Save more on wholesale packs of 20+ before the deal expires.",     href: "/offers",         time: "5h ago" },
  { id: "n3", type: "product", title: "New arrival: Woodpecker AI Endo Motor", body: "Restock alert for the item you added to wishlist.",               href: "/shop?q=endo+motor", time: "Yesterday" },
  { id: "n4", type: "reward",  title: "You earned 120 Dyntra Coins",           body: "Redeem your rewards on your next order at checkout.",             href: "/rewards",        time: "2 days ago" },
  { id: "n5", type: "info",    title: "New feature: image search",             body: "Snap or upload a photo — Dr. Dyntra finds the closest match instantly.", href: "/",       time: "1 week ago" },
];

export default function NotificationsPage() {
  return (
    <main className="dyntra-container py-10 max-w-3xl">
      <div className="flex items-center gap-3 mb-8">
        <div className="h-11 w-11 rounded-2xl bg-[#F3EFFC] flex items-center justify-center">
          <Bell className="h-5 w-5 text-[#4B2AAD]" />
        </div>
        <div>
          <h1 className="font-display text-3xl font-bold text-gray-900">Notifications</h1>
          <p className="text-sm text-gray-500">Order updates, offers, and product news — all in one place.</p>
        </div>
      </div>

      <ul className="rounded-2xl border border-gray-100 bg-white divide-y divide-gray-100 shadow-sm overflow-hidden">
        {NOTIFICATIONS.map((n) => {
          const Ico = ICONS[n.type] || Info;
          return (
            <li key={n.id}>
              <Link to={n.href} className="flex gap-4 px-5 py-4 hover:bg-[#F8F9FA] transition-colors">
                <div className="h-10 w-10 rounded-xl bg-[#F3EFFC] flex items-center justify-center shrink-0">
                  <Ico className="h-5 w-5 text-[#4B2AAD]" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-semibold text-gray-900">{n.title}</p>
                  <p className="text-sm text-gray-600 mt-0.5 line-clamp-2">{n.body}</p>
                  <p className="text-[11px] text-gray-400 mt-1.5">{n.time}</p>
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </main>
  );
}
